<template>
  <div class="login">
    <div class="header">
      <div class="logo" @click="goBack"></div>
<!--      <div class="title">“ e路通 ”{{ title }}登录</div>-->
      <div class="title">道路交通事故处理一体化处理服务平台</div>
      <div class="head_right">
<!--        <div class="subtitle">道路交通事故处理一体化处理服务平台</div>-->
        <div class="time" v-text="time"></div>
        <div class="weather">多云 / PM 2.5 / 良好</div>
      </div>
    </div>
    <div class="login-wrapper">
      <div class="logo2">
        <img src="../assets/sites/logo.png" alt=""  style="margin-top: 20px"/>
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        class="login-form"
      >
        <el-form-item size="medium">
          <customInp :inputVal="loginForm.username" @changeInp="(val)=>{loginForm.username=val}" :placeholder="'请输入账号'" :suffixIcon="suffixIcon">
            <img slot="prefixIcon" src="../assets/sites/icon1.png" alt="" />
          </customInp>
        </el-form-item>
        <el-form-item>
          <customInp :inputVal="loginForm.password" @changeInp="(val)=>{loginForm.password=val}" :placeholder="'请输入密码'" :suffixIcon="suffixIcon" :inpType="'password'">
            <img slot="prefixIcon" src="../assets/sites/icon2.png" alt="" />
          </customInp>
        </el-form-item>
        <el-form-item class="login-code-wrapper">
          <customInp
            :inputVal="loginForm.code"
            @changeInp="(val)=>{loginForm.code=val}"
            :placeholder="'请输入验证码'"
            style="width: 265px"
            :suffixIcon="suffixIcon"
          >
            <img slot="prefixIcon" src="../assets/sites/icon3.png" alt="" />
          </customInp>
          <div class="login-code">
            <img :src="codeUrl" class="login-code-img" @click="getCode" />
          </div>
        </el-form-item>
        <el-checkbox
          v-model="loginForm.rememberMe"
          class="rember"
        >
        <span style="font-size: 14px;letter-spacing: 2px;">记住账号密码</span>
        </el-checkbox>
        <el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            :class="allowLogin?'loginBtn1':'loginBtn2'"
            :disabled="allowLogin?false:true"
            @click.native.prevent="handleLogin"
          >
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
          <div class="version">
            版本号: 20211119-01
          </div>
        </el-form-item>
      </el-form>
    </div>
<!--    <img class="foot" src="../assets/sites/foot.png" alt="" />-->
  </div>
</template>

<script>
import { getCodeImg } from "@/api/login-util";
import Cookies from "js-cookie";
import { parseTime } from "@/utils/ruoyi";
import { decrypt, encrypt } from "@/utils/jsencrypt";
import customInp from "@/components/customInp";
export default {
  name: "Login",
  components: { customInp },
  data() {
    return {
      title: "远程定责",
      codeUrl: "",
      cookiePassword: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
      },
      // loginRules: {
      //   username: [
      //     { required: true, trigger: "blur", message: "用户名不能为空" },
      //   ],
      //   password: [
      //     { required: true, trigger: "blur", message: "密码不能为空" },
      //   ],
      //   code: [
      //     { required: true, trigger: "change", message: "验证码不能为空" },
      //   ],
      // },
      loading: false,
      redirect: undefined,
      time: null,
      suffixIcon: require('../assets/sites/icon4.png'), // 删除按钮
      allowLogin: false
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
    loginForm:{
      handler(val) {
        console.log(val);
        if (val.username && val.password && val.code) {
          this.allowLogin = true
        }else {
          this.allowLogin = false
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getCode();
    this.getCookie();
    this.getSystemTitle();
    const time = parseTime(Date.now(), undefined);
    this.time = time.substr(0, 16).replace(/\-/g, "/");
  },
  mounted() {
    this.$nextTick(()=>{
      document.onkeydown = (ev) => {
        let event = ev ||event
        if(event.keyCode === 13){
          this.handleLogin();
        }
      }
    })

  },
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password:
          password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        code: this.loginForm.code
      };
    },
    handleLogin() {
      console.log(this.loginForm);
      if (this.loginForm.username && this.loginForm.username && this.loginForm.code) {
        this.loading = true;
        if (this.loginForm.rememberMe) {
          Cookies.set("username", this.loginForm.username, { expires: 30 });
          Cookies.set("password", encrypt(this.loginForm.password), {
            expires: 30,
          });
          Cookies.set("rememberMe", this.loginForm.rememberMe, {
            expires: 30,
          });
        } else {
          Cookies.remove("username");
          Cookies.remove("password");
          Cookies.remove("rememberMe");
        }
        this.$store
        .dispatch("Login", this.loginForm)
        .then(() => {
          this.$router.push({ path: this.redirect || "/" }).catch(() => {});
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.getCode();
        });
      }
    },
    goBack() {
      this.$router.push("/");
    },
    getSystemTitle() {
      switch (localStorage.getItem("loginType")) {
        case "3183":
          this.title = "远程定责";
          break;
        case "3185":
          this.title = "远程调解";
          break;
        case "3187":
          this.title = "一键救援";
          break;
        case "3191":
          this.title = "一键理赔";
          break;
        case "3193":
          this.title = "警情地图";
          break;
        default:
          this.title = "远程定责";
          break;
      }
    }
  },
};
</script>
<style lang='scss'>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../assets/sites/bg.png") no-repeat;
  background-size: 100% 100%;
  .header {
    position: relative;
    width: 100%;
    height: 60px;
    background-color: rgba(0,0,0,0.7);
    .logo {
      width: 126px;
      height: 60px;
      position: absolute;
      left: 0;
      top: 0;
      background: url("../assets/sites/back1.png") no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        background: url("../assets/sites/back2.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .title {
      position: absolute;
      color: #d5f0ff;
      font-size: 20px;
      left: 136px;
      height: 60px;
      line-height: 60px;
      letter-spacing: 6px;
      cursor: pointer;
      text-shadow: 0px 2px 8px #4b7dff, 0px 0px 2px #2fc5ff;
    }
    .head_right {
      position: absolute;
      right: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 60px;
      line-height: 60px;
      .subtitle {
        color: #9dc4ec;
        font-size: 24px;
      }
      .weather {
        color: #d3e9ff;
        font-size: 16px;
        //margin: 0 20px 0 40px;
        width: 186px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        //background: url("../assets/sites/weather.png") no-repeat;
        //background-size: 100% 100%;
      }
      .time {
        color: #d3e9ff;
        font-size: 16px;
        //margin: 0 40px 0 20px;
        width: 166px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        //background: url("../assets/sites/time.png") no-repeat;
        //background-size: 100% 100%;
      }
    }
  }
  .login-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 505px;
    height: 600px;
    padding: 20px;
    background: url("../assets/sites/login.png") no-repeat;
    background-size: 100% 100%;
    .logo2 {
      text-align: center;
      margin-top: 10px;
    }
    .login-form {
      padding: 0 42px;
      .el-form-item {
        margin-bottom: 36px;
      }
      .login-code-wrapper {
        position: relative;
        .login-code {
          img {
            position: absolute;
            right: 5px;
            top: 0;
            height: 36px;
            cursor: pointer;
            vertical-align: middle;
          }
        }
      }
    }
    .loginBtn1 {
      width: 100%;
      height: 50px;
      border-color: #1890ff;
      background-color: #1890ff;
      margin-top: 15px;
      font-size: 22px;
      &:hover,
      :focus {
        background-color: #1890ff;
      }
    }
    .loginBtn2 {
      width: 100%;
      height: 50px;
      border: none;
      background-color: #374262;
      margin-top: 15px;
      font-size: 24px;
      color: #536391;
    }
    .version {
      font-size: 12px;
      color: #666666;
    }
    .rember {
      margin: 0px 0px 25px 0px;
      color: #17ecfe;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #17ecfe;
      }
      .el-checkbox__inner {
        background-color:transparent;
        border:1px solid #17ecfe;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: transparent;
        border-color: #17ecfe;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,.el-checkbox__inner:hover,.el-checkbox__inner::after {
        border-color: #17ecfe;
      }
    }
  }
  .foot {
    position: absolute;
    bottom: 28px;
    left: 0;
    right: 0;
    margin: auto;
  }

}
</style>
